<template lang="pug">
v-app
  nuxt
</template>
<script>
export default {
	name: 'EmptyLayout'
};
</script>
